/**
 * Enhances accessibility by adding ARIA labels to external links
 * that open in a new tab. Helps screen readers notify users properly.
 *
 * @returns {void}
 */
function addAriaToExternalLinks() {
    /**
     * Adds `aria-label` to qualifying anchor elements.
     *
     * @returns {void}
     */
    function applyAriaLabels() {
        const externalLinks = document.querySelectorAll('a[target="_blank"]');

        externalLinks.forEach((link) => {
            // Skip if already labeled
            if (link.hasAttribute('aria-label')) {
                return;
            }

            // Determine label content
            const labelText =
                link.textContent.trim() ||
                link.getAttribute('title') ||
                link.getAttribute('href');

            if (labelText) {
                link.setAttribute(
                    'aria-label',
                    `${labelText} (opens in a new tab)`,
                );
            }
        });
    }

    // Execute once DOM is ready
    document.addEventListener('DOMContentLoaded', applyAriaLabels);
}

export default addAriaToExternalLinks;
